import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns as AdapterDateFnsForV3 } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { useTheme } from '../context/ThemeContext';
import { createAppMuiTheme } from './muiAppTheme';

/**
 * Bridges app light/dark preference to MUI + MUI X pickers (date-fns).
 * Does not inject CssBaseline — global styles stay in index.css.
 */
export function MuiAppProvider({ children }) {
  const { resolvedTheme } = useTheme();
  const muiTheme = useMemo(
    () => createAppMuiTheme(resolvedTheme === 'dark' ? 'dark' : 'light'),
    [resolvedTheme]
  );

  return (
    <ThemeProvider theme={muiTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFnsForV3}>
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
